import { CreateGUFWellFunctionTask, EditGUFWellFunctionTask } from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickGufLibraryFields } from "./guf-schema-library";

const sharedTitle = (type: FormType | undefined) => `GUF Putfunctie ${getTitleAddon(type)}`;
const sharedDescription = `Dit is het GUF putfunctie formulier. ${getDocsLinkMarkdown("GUF")}`;

const realisedInstallationFunctionSchema = {
  type: "object" as const,
  title: "Gerealiseerde installatiefunctie",
  required: ["realisedInstallationId", "installationFunction"],
  properties: pickGufLibraryFields(["realisedInstallationId", "installationFunction"]),
};

const sharedSourcedocumentData = {
  type: "object" as const,
  title: "Brondocumentgegevens",
  required: ["realisedWellId", "wellFunctions", "eventDate"],
  properties: {
    ...pickGufLibraryFields([
      "realisedWellId",
      "wellFunctions",
      "relativeTemperature",
      "eventDate",
    ]),
    realisedInstallationFunction: realisedInstallationFunctionSchema,
  },
};

const getGufWellFunctionCreateSchema = (
  type: FormType | undefined
): SchemaForFormData<CreateGUFWellFunctionTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      title: "Metadata",
      required: ["projectNumber", "deliveryAccountableParty", "qualityRegime", "broId"],
      properties: pickGufLibraryFields([
        "projectNumber",
        "qualityRegime",
        "deliveryAccountableParty",
        "broId",
      ]),
    },
    sourcedocumentData: sharedSourcedocumentData,
  },
});

const getGufWellFunctionEditSchema = (
  type: FormType | undefined
): SchemaForFormData<EditGUFWellFunctionTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      title: "Metadata",
      required: [
        "projectNumber",
        "deliveryAccountableParty",
        "qualityRegime",
        "broId",
        "correctionReason",
      ],
      properties: {
        ...pickGufLibraryFields([
          "projectNumber",
          "qualityRegime",
          "deliveryAccountableParty",
          "correctionReason",
        ]),
        broId: { ...pickGufLibraryFields(["broId"]).broId, readOnly: true },
      },
    },
    sourcedocumentData: sharedSourcedocumentData,
  },
});

export function getGufWellFunctionSchema(args: {
  type: FormType | undefined;
  isEditing: true;
}): SchemaForFormData<EditGUFWellFunctionTask>;
export function getGufWellFunctionSchema(args: {
  type: FormType | undefined;
  isEditing: false;
}): SchemaForFormData<CreateGUFWellFunctionTask>;
export function getGufWellFunctionSchema(args: {
  type: FormType | undefined;
  isEditing: boolean;
}): SchemaForFormData<EditGUFWellFunctionTask> | SchemaForFormData<CreateGUFWellFunctionTask>;
export function getGufWellFunctionSchema({
  type,
  isEditing,
}: {
  type: FormType | undefined;
  isEditing: boolean;
}) {
  return isEditing ? getGufWellFunctionEditSchema(type) : getGufWellFunctionCreateSchema(type);
}
